module.exports = __webpack_public_path__ + "media/assets/images/shopping/flag-fa8582346de14c96b955ca23a7599d85.svg";